import { IManagerProductContext } from "Interfaces/Providers/ManagerProduct";
import { ManagerProductContext } from "providers/Settings/ManagerProductProvider";
import { useContext } from "react";

export default function useManagerProduct(): IManagerProductContext {
  const context = useContext(ManagerProductContext);

  return context;
}
